import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { classNames } from '../../../utils';
import Need from './need';
import Plan from './plan';
import History from './history';

const TAB = {
  NEED: 1,
  PLAN: 2,
  HISTORY: 3,
}

const Users = () => {
  const location = useLocation();
  const [tab, setTab] = useState();

  useEffect(() => {
    if (location.pathname.endsWith('/plan')) {
      setTab(TAB.PLAN);
    } else if (location.pathname.endsWith('/history')) {
      setTab(TAB.HISTORY);
    } else {
      setTab(TAB.NEED);
    }
  }, [location.pathname]);

  return (
    <main className="p-4 w-full">
      {tab === TAB.NEED && (
        <Need tabs={<Tabs tab={tab} setTab={setTab} />} />
      )}
      {tab === TAB.PLAN && (
        <Plan tabs={<Tabs tab={tab} setTab={setTab} />} />
      )}
      {tab === TAB.HISTORY && (
        <History tabs={<Tabs tab={tab} setTab={setTab} />} />
      )}
    </main>
  );
};

const Tabs = ({ tab, setTab }) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-4 my-2">
      <Tab
        label="Necesidades de Mantenimiento"
        isActive={tab === TAB.NEED}
        onClick={() => navigate('/maintenance')}
      />
      <Tab
        label="Plan de Mantenimiento"
        isActive={tab === TAB.PLAN}
        onClick={() => navigate('/maintenance/plan')}
      />
      <Tab
        label="Historial de Mantenimiento"
        isActive={tab === TAB.HISTORY}
        onClick={() => navigate('/maintenance/history')}
      />
    </div>
  )
}

const Tab = ({ label, icon, isActive, onClick }) => (
  <button
    className={classNames('flex items-center gap-2 p-3 rounded-xl text-sm font-semibold shadow-md', isActive ? 'bg-orange' : 'bg-white')}
    onClick={onClick}
  >
    <span className={classNames(' text-lg', isActive ? 'text-white' : 'black')}>{ label }</span>
  </button>
)

export default Users;